import React, {Component } from 'react';
import { Drawer, Breadcrumb, Card,Table, DatePicker,Button,Tooltip,Modal,Form,Input, Upload,Select,Spin,Divider,InputNumber,Menu, Dropdown, Progress } from 'antd';
import { WalletOutlined,SendOutlined,EditOutlined,DeleteOutlined,CloudUploadOutlined, UploadOutlined,DownOutlined,ExclamationCircleOutlined,WarningOutlined,DoubleRightOutlined } from '@ant-design/icons';
import {Row, Col} from 'react-bootstrap';
import mHelper from './../../config/Helper';
import mPaidControllers from './../../control/paid/index.controller';
import moment from 'moment';
import reqwest from 'reqwest';
import HeaderTitle from '../../component/HeaderTitle/HeaderTitle'
var isLogin = JSON.parse(mHelper.GET_COOKIES('login_portal'));

const layout = {
    labelCol: {
      span: 10,
    },
    wrapperCol: {
      span: 14,
    },
};

const layoutPendukung = {
    labelCol: {
      span: 5,
    },
    wrapperCol: {
      span: 19,
    },
};



var thisComponent;
var formUploadInvoice = React.createRef();
const { Option } = Select;
const { TextArea } = Input;
const { confirm } = Modal;

class UploadInvoice extends Component {

    constructor(props) {
        super(props);
        this.state = {
            AdCode : isLogin.company.ad_code,
            AdName : isLogin.company.ad_name,
            TableUploadInvoice  : [],
            Periode: mHelper.GET_DATE_DIGIPOS(),
            PeriodeInvoice : mHelper.GET_DATE_DIGIPOS(),
            qty_invoice : 0,
            price_invoice:0,
            modalFormUploadInvoice : false,
            fileInvoice : [],
            invoiceLookup:[],
            fileFakturPajak : [],
            fakturPajakLookup:[],
            fileBARRecon : [],
            fileSummary : [],
            loadingUploadInvoice : false,
            typeTrx : 1,
            InvSelected : "",
            UploadInvProgress : 0,
            UploadFpProgress : 0,
            UploadBarProgress : 0,
            count_note : 0,
            data_price : {qty_trx : 1 ,price : 0 , pph_amount :0 , total_amount : 0},
            drawerMessage : false,
        };
        thisComponent = this;
    }

    async componentDidMount() {
        this.onRefreshDataInvoice();
        this.onRefreshInvoiceLookup();
        this.onRefreshFakturPajakLookup();
        this.onGetDataDigipos(this.state.PeriodeInvoice,this.state.AdCode);
    }

    onGetDataDigipos = (periode , ad_code) => {
        var FilterData = {where : { and :  [{trx_date_group: periode},{ ad_code:ad_code}] }}
        // this.setState({loadingUploadInvoice : true});
        mPaidControllers.GET_DATA_DIGIPOS(FilterData,(r)=>{
            // console.log(r);
            for(var i in r){
                var rawDataDigipos = r[i];
                //if(rawDataDigipos.trx_date_group == periode){
                    this.setState({data_price  :{qty_trx : 1 ,price : rawDataDigipos.dpp_fee_amount , pph_amount :rawDataDigipos.vat_fee_amount , total_amount :rawDataDigipos.total_fee_amount}})
                //}
            }
            
            if(r.length == 0){
                this.setState({data_price  :{qty_trx : 1 ,price : 0 , pph_amount :0 , total_amount :0}})
            }
            // this.setState({loadingUploadInvoice : false});
            if(this.state.InvSelected != ""){
                thisComponent.onUpdateDataInvoice({
                    qty_trx : thisComponent.state.data_price.qty_trx ,
                    price : thisComponent.state.data_price.price , 
                    pph_amount :thisComponent.state.data_price.pph_amount , 
                    total_amount :thisComponent.state.data_price.total_amount
                });
                formUploadInvoice.current.setFieldsValue({ 
                    qty_trx :thisComponent.state.data_price.qty_trx,
                    pph_amount : thisComponent.state.data_price.pph_amount,
                    price : thisComponent.state.data_price.price,
                    total_amount : thisComponent.state.data_price.total_amount,
                });
            }
        });
    }

  
    onRefreshInvoiceLookup = () => {
        var datas = [];
        for(var i =0; i < 40; i++){
            datas.push({
                key:i,
                value:i,
                label : "00000"+i+"-01-2020-10"
            });
        }
        this.state.invoiceLookup = datas;
    }

    onRefreshFakturPajakLookup = () => {
         var datas = [];
        for(var i =0; i < 40; i++){
            datas.push({
                key:i,
                value:i,
                label : "010.10.0000"+i
            });
        }
        this.state.fakturPajakLookup = datas;
    }

    onRefreshDataInvoice = () => {
        this.setState({loadingUploadInvoice: true});
        // this.state.loadingUploadInvoice = true;
        var filter = {where: { and: [ {periode : this.state.Periode}, {type_trx : this.state.typeTrx },{ad_code : this.state.AdCode}] } };
        // console.log();
        mPaidControllers.GET_DATA_INVOICE(filter,(r)=>{
            var datas = [];
            this.setState({count_note : 0});
            for(var  i in r){
                var infoRaw = r[i];
                var status = ["Draft","Waiting Validate...","Waiting Approval...","Proses  by Treasury...","Finish","Reject","Waiting Approval..." ];
                var FileAttach = [];
                var barStore = infoRaw.bar_attachment == null ? [] : infoRaw.bar_attachment.split(";");
                for(var iBAR in barStore){
                    FileAttach.push({title : "DOC BAR RECON #"+(parseInt(iBAR)+1) ,  fileName : barStore[iBAR]});
                }
                if(infoRaw.inv_attahment !== null){ FileAttach.push({title : "DOC INVOICE" ,  fileName : infoRaw.inv_attahment}); }
                if(infoRaw.fp_attachment !== null){ FileAttach.push({title : "DOC FAKTUR PAJAK" ,  fileName : infoRaw.fp_attachment}); }
                if(infoRaw.summary_attachment !== null){ FileAttach.push({title : "DOC SUMMARY" ,  fileName : infoRaw.summary_attachment}); }
                datas.push({
                    key:infoRaw.id,
                    action : infoRaw.id,
                    periode_trx : infoRaw.periode,
                    ad_code : infoRaw.ad_code,
                    ad_name:infoRaw.ad_name,
                    inv_number :infoRaw.inv_number,
                    description : infoRaw.description,
                    inv_qty : infoRaw.qty_trx,
                    price : mHelper.GENERATE_PULUHAN(infoRaw.price == null ? 0 : infoRaw.price),
                    pph_amount : mHelper.GENERATE_PULUHAN(infoRaw.pph_amount == null ? 0 : infoRaw.pph_amount),
                    total_amount : mHelper.GENERATE_PULUHAN(infoRaw.total_amount == null ? 0 : infoRaw.total_amount ),
                    remarks : infoRaw.remarks,
                    file : {
                        key : i,
                        info :FileAttach
                    },
                    status:infoRaw.fpjp_hold_state == 1 &&  infoRaw.state == 3 ? "Review AP..." : status[infoRaw.state] ,
                    state : infoRaw.state,
                    note : {hold_state : infoRaw.fpjp_hold_state , note_state : infoRaw.fpjp_note_state,desc : infoRaw.fpjp_note} 
                });

                if(infoRaw.state !== 0 && infoRaw.state !== 1  && infoRaw.state !== 5 ){
                    var note = this.state.count_note+1;
                    this.setState({count_note :note});
                    // this.state.count_note = note;
                }
            }
            // this.state.TableUploadInvoice = datas;
            // this.state.loadingUploadInvoice = false;
            this.setState({TableUploadInvoice :datas, loadingUploadInvoice : false});
        });
    }

    onUploadInvoice = () => {
        this.setState({loadingUploadInvoice:true});
        mPaidControllers.ADD_INVOICE_DRAFT(
            this.state.PeriodeInvoice,
            this.state.AdCode == null ? "-" : this.state.AdCode,
            this.state.AdName == null ? "-" : this.state.AdName,
            this.state.typeTrx,
            mHelper.CURRENT_TIME_MILIS().toString(),
            isLogin.id,(r)=>{
                if(r.success == true){
                    this.setState({modalFormUploadInvoice:true});
                    setTimeout(()=>{
                        formUploadInvoice.current.resetFields();
                        this.setState({loadingUploadInvoice:false, InvSelected : r.data.id, fileBARRecon:[], fileFakturPajak : [], fileInvoice : [],fileSummary : []});
                        formUploadInvoice.current.setFieldsValue({ 
                            ad_code: this.state.AdCode,
                            ad_name:this.state.AdName,
                            periode : this.state.PeriodeInvoice ,
                            type_trx : this.state.typeTrx
                        });
                        this.onGetDataDigipos(this.state.PeriodeInvoice,this.state.AdCode);
                        
                    },2000);
                }else{
                    Modal.info({
                        title: 'Error',
                        content: (
                          <div>
                            <p>{r.message}</p>
                          </div>
                        ),
                        onOk() {},
                    });
                    this.setState({modalFormUploadInvoice:false, loadingUploadInvoice:false});
                }
        });
    }

    onChangeDate = (date, dateString) => {
        // console.log(dateString);
        this.setState({Periode:dateString, PeriodeInvoice :dateString});
    }

    onChangeDateInv = (date, dateString)=> {
        this.onUpdateDataInvoice({inv_date : dateString});
    }

    onChangeDataInvoice = (date, dateString) => {
        
        this.setState({PeriodeInvoice:dateString , data_price : {qty_trx : 1 ,price : 0 , pph_amount :0 , total_amount : 0}});
        this.onGetDataDigipos(dateString,this.state.AdCode);
        mPaidControllers.UPDATE_INVOICE_DATA(this.state.InvSelected,{
            periode : dateString, 
            ad_code : this.state.AdCode,
            ad_name : this.state.AdName,
            type_trx : this.state.typeTrx,
            at_create :mHelper.CURRENT_TIME_MILIS().toString(),
            by_create : isLogin.id
        },
        (r)=>{
            // console.log(r);
        })
        // this.onUpdateDataInvoice("periode",dateString);
    }

    onUpdateDataInvoice = (raw) => {
        var info = {};
        // console.log(raw);
        info["periode"] = this.state.PeriodeInvoice;
        info["ad_code"] = this.state.AdCode;
        info["ad_name"] = this.state.AdName;
        info["type_trx"] = this.state.typeTrx;
        info["at_create"] = mHelper.CURRENT_TIME_MILIS().toString();
        info["by_create"] =isLogin.id;
        // info[key] = values;
        for(var i in raw){
            info[i] = raw[i];
        }
        mPaidControllers.UPDATE_INVOICE_DATA(this.state.InvSelected,info,(r)=>{
            // console.log(r);
        });
    }

    onCancelFormUploadInvoice = () => {
        this.onRefreshDataInvoice();
        this.setState({modalFormUploadInvoice:false});
    }
    
    onSubmitInvoice = (row) => {
        if(this.state.fileBARRecon.length === 0){
            Modal.info({
                title: 'Error',
                content: (
                  <div>
                    <p>File Document BAR Recon harus di upload tidak boleh kosong  !</p>
                  </div>
                ),
                onOk() {},
            });
            return;
        }
        if(this.state.fileInvoice.length === 0){
            Modal.info({
                title: 'Error',
                content: (
                  <div>
                    <p>File Document Invoice harus di upload tidak boleh kosong !</p>
                  </div>
                ),
                onOk() {},
            });
            return;
        }
        if(this.state.fileFakturPajak.length === 0){
            Modal.info({
                title: 'Error',
                content: (
                  <div>
                    <p>File Document Faktur Pajak harus di upload tidak boleh kosong !</p>
                  </div>
                ),
                onOk() {},
            });
            return;
        }

        if(this.state.fileSummary.length === 0){
            Modal.info({
                title: 'Error',
                content: (
                  <div>
                    <p>File DocumentSummary harus di upload tidak boleh kosong !</p>
                  </div>
                ),
                onOk() {},
            });
            return;
        }

       

        mPaidControllers.SUBMIT_INVOICE(this.state.InvSelected,(r)=>{
            formUploadInvoice.current.resetFields();
            this.onRefreshDataInvoice();
            this.setState({modalFormUploadInvoice:false,fileBARRecon :[], fileInvoice : [], fileFakturPajak : []});
            mHelper.ON_SEND_MESSAGE_NOTIF({
                types: "NOTIFICATION",
                target: "1,4,5",
                to: "",
                from_who: this.state.AdCode,
                subject: "Data FPJP Invoice telah disubmit oleh AD ",
                body: "Document FPJP Invoice berhasil di submit oleh : "+ this.state.AdName,
                path_url: "",
                app: "DIGIPOS",
                code: "15010102",
                code_label: "",
                at_create: mHelper.CURRENT_TIME_MILIS(),
                at_read: "",
                periode:  this.state.PeriodeInvoice,
                at_flag: 0
            });
        });
    }

    onFinishFormUploadInvoice = (row) => {
        confirm({
            title: 'Submit Invoice',
            icon: <ExclamationCircleOutlined />,
            content: 'Kamu yakin ingin sumbmit data invoice ini ? ( * invoice yang sudah disumbmit tidak akan bisa di edit / dihapus )',
            onOk() {
               thisComponent.onSubmitInvoice(row);
            },
            onCancel() {
            },
        });
        
    }

    onChangeQtyInvoice = (values) => {
        var Qty = values == "" || values == null ? 0 : values;
        this.setState({qty_invoice : Qty});
        var PriceTotal = parseFloat(Qty) * parseFloat(this.state.price_invoice);
        var Pph    = ( PriceTotal * 0.1);
        var Total  = PriceTotal + Pph;
        formUploadInvoice.current.setFieldsValue({ 
            total_amount :Total,
            pph_amount: Pph ,
            qty_trx:Qty
        });
        this.onUpdateDataInvoice({"qty_trx":values, total_amount : Total , pph_amount : Pph});
    }

    onChangePriceInvoice = (values) => {
        // console.log(values);
        var Price = values == "" || values == null ? 0 : values;
        this.setState({price_invoice : Price});
        var PriceTotal = parseFloat(Price) * parseFloat(this.state.qty_invoice);
        var Pph    = ( PriceTotal * 0.1);
        var Total  = PriceTotal + Pph;
        formUploadInvoice.current.setFieldsValue({ 
            total_amount :Total,
            pph_amount: Pph ,
            qty_trx:this.state.qty_invoice
        });
        this.onUpdateDataInvoice({"price":values, total_amount : Total , pph_amount : Pph});
    }
    
 
    handleOpenFile = (e,info) => {
        console.log(e.key,info);
        var FileInfo = info[e.key];
        var folder = "bar_recon";
        switch(FileInfo.title){
            case "DOC BAR RECON #1" :
                folder ="bar_recon";
            case "DOC BAR RECON #2" :
                folder ="bar_recon";
                break;
            case "DOC INVOICE" :
                folder ="paid";
                break;
            case "DOC FAKTUR PAJAK" :
                folder ="faktur_pajak";
                break;
            case "DOC SUMMARY" :
                folder ="summary";
                break;
            default :
                folder ="bar_recon";
                break;
        }
        mPaidControllers.GET_FILE_DOC({folder :folder,names:FileInfo.fileName },(r)=>{
            if(r.success == true){
                const buff = Buffer.from(r.data, "base64");
                const file = new Blob([buff],{type: 'application/pdf'});
                const fileURL = URL.createObjectURL(file);
                window.open(fileURL);
            }else{
                Modal.info({
                    title: 'Error',
                    content: (
                      <div>
                        <p>File tidak bisa ditemukan !</p>
                      </div>
                    ),
                    onOk() {},
                });
            }
        });
    }   

    onProcess = () => {
        this.setState({qty_invoice : 0 , price_invoice :  0});
        this.onRefreshDataInvoice();
    }

    handelUpdateInvoice = (id) => {
        
        this.setState({loadingUploadInvoice:true});
        mPaidControllers.GET_SELECT_INVOICE(id,(r)=>{
            if(r.state != 0 && r.state !== 5 && r.fpjp_hold_state !=1){
                this.setState({loadingUploadInvoice:false});
                Modal.info({
                    title: 'Error',
                    content: (
                      <div>
                        <p>Tidak bisa merubah  invoice kecuali status invoice draft / reject !</p>
                      </div>
                    ),
                    onOk() {},
                });
                return;
            }
            this.setState({modalFormUploadInvoice:true,InvSelected : id, fileBARRecon : [], fileInvoice : [], fileFakturPajak : []});
            setTimeout(()=>{
                formUploadInvoice.current.resetFields();
                    var bar = r.bar_attachment === null || r.bar_attachment === "" ? []:r.bar_attachment.split(";");
                    var flielBAR = [];
                    for(var iBAR in bar){
                        var infoBar = bar[iBAR];
                        flielBAR.push({uid: id + "_" + (infoBar + 1), name: infoBar, status: 'done'});
                    }
                    var fileInv = r.inv_attahment === "" || r.inv_attahment === null ? [] : [{uid: id , name: r.inv_attahment, status: 'done'}];
                    var fileFp = r.fp_attachment === "" || r.fp_attachment === null ? [] : [{uid: id , name: r.fp_attachment, status: 'done'}];
                    var fileSm = r.summary_attachment === "" || r.summary_attachment === null ? [] : [{uid: id , name: r.summary_attachment, status: 'done'}];

                    this.setState({fileBARRecon : flielBAR, fileInvoice : fileInv, fileFakturPajak : fileFp, fileSummary : fileSm});
                    formUploadInvoice.current.setFieldsValue({ 
                        ad_code: this.state.AdCode,
                        ad_name:this.state.AdName,
                        periode : r.periode ,
                        inv_number : r.inv_number,
                        fp_number : r.fp_number,
                        description : r.description,
                        qty_trx : r.qty_trx,
                        price : r.price,
                        pph_amount : r.pph_amount,
                        total_amount : r.total_amount,
                        remarks : r.remarks,
                        inv_date :moment(r.inv_date, "YYYY-MM-DD")
                    });
                    this.setState({loadingUploadInvoice:false,qty_invoice : r.qty_trx , price_invoice :  r.price});
            },2000);
        });
    }

    handleDeleteInvoice = (id) => {
        mPaidControllers.GET_SELECT_INVOICE(id,(r)=>{
            if(r.state != 0 ){
                this.setState({loadingUploadInvoice:false});
                Modal.info({
                    title: 'Error',
                    content: (
                      <div>
                        <p>Tidak bisa menghapus  invoice kecuali status invoice draft !</p>
                      </div>
                    ),
                    onOk() {},
                });
                return;
            }
            confirm({
                title: 'Confirm',
                icon: <ExclamationCircleOutlined />,
                content: 'Kamu yakin ingin menghapus data ini ?',
                onOk() {
                    mPaidControllers.DELETE_INVOICE(id,(r)=>{
                        thisComponent.onRefreshDataInvoice();
                    })
                },
                onCancel() {
                },
            });
        });
    }


    //UPLOAD INVOICE
    handleUploadInvoiceChange = info => {
        let fileList = [...info.fileList];
        this.setState({ fileInvoice: fileList });
    }

    removeInvoice = file =>{
        // console.log(file);
        mPaidControllers.DELETE_FILE_INVOICE(parseInt(file.uid),"invoice",file.name,(r)=>{
            // console.log(r);
        });
        this.setState(state => {
            const index = state.fileInvoice.indexOf(file);
            const newFileList = state.fileInvoice.slice();
            newFileList.splice(index, 1);
            return {
                fileInvoice: newFileList,
            };
        });
    }

    uploadInvoice = async options => {
        const { onSuccess, onError, file, onProgress } = options;
        const formData = new FormData();
        const config = {
          headers: { "content-type": "multipart/form-data" },
          onUploadProgress: event => {
            const percent = Math.floor((event.loaded / event.total) * 100);
            this.setState({UploadInvProgress:percent})
            if (percent === 100) {
              setTimeout(() => {
                this.setState({UploadInvProgress:0});
              }, 1000);
            }
            onProgress({ percent: (event.loaded / event.total) * 100 });
          }
        };
        formData.append("id", this.state.InvSelected);
        formData.append("periode", this.state.PeriodeInvoice);
        formData.append("ad_code", this.state.AdCode);
        formData.append("ad_name", this.state.AdName);
        formData.append("doc_invoice", file);
        reqwest({
            url: mHelper.URL_API() + "paid-invoice/upload_invoice",
            method: 'post',
            headers: {
                "Authorization": "Bearer " + isLogin.token
            },
            processData: false,
            data: formData,
            success: (r) => {
                onSuccess("Ok");
                this.setState({fileInvoice:[r.data]});
            },
            error: (err) => {
                onError({ err });
            },
        });
    }

    //UPLOAD FAKTUR PAJAK
    handleUploadFpChange = info => {
        let fileList = [...info.fileList];
        this.setState({ fileFakturPajak: fileList });
    }

    removeFp = file =>{
        // console.log(file);
        mPaidControllers.DELETE_FILE_INVOICE(parseInt(file.uid),"fp",file.name,(r)=>{
            // console.log(r);
        });
        this.setState(state => {
            const index = state.fileFakturPajak.indexOf(file);
            const newFileList = state.fileFakturPajak.slice();
            newFileList.splice(index, 1);
            return {
                fileFakturPajak: newFileList,
            };
        });
    }

    uploadFp = async options => {
        const { onSuccess, onError, file, onProgress } = options;
        const formData = new FormData();
        const config = {
          headers: { "content-type": "multipart/form-data" },
          onUploadProgress: event => {
            const percent = Math.floor((event.loaded / event.total) * 100);
            this.setState({UploadInvProgress:percent})
            if (percent === 100) {
              setTimeout(() => {
                this.setState({UploadInvProgress:0});
              }, 1000);
            }
            onProgress({ percent: (event.loaded / event.total) * 100 });
          }
        };
        formData.append("id", this.state.InvSelected);
        formData.append("periode", this.state.PeriodeInvoice);
        formData.append("ad_code", this.state.AdCode);
        formData.append("ad_name", this.state.AdName);
        formData.append("doc_fp", file);
        reqwest({
            url: mHelper.URL_API() + "paid-invoice/upload_fp",
            method: 'post',
            headers: {
                "Authorization": "Bearer " + isLogin.token
            },
            processData: false,
            data: formData,
            success: (r) => {
                // if (file.status === 'done'){
                //     file.name ="ZZZZZZ.pdf";
                    // let fileInvoice = [...file];
                    
                // }
              
                onSuccess("Ok");
                this.setState({fileFakturPajak:[r.data]});
                
            },
            error: (err) => {
                onError({ err });
                // callback({success:false, data:[], message : "add paid invoice  error"});
            },
        });
    }


    //UPLOAD BAR
    handleUploadBarChange = info => {
        let fileList = [...info.fileList];
        this.setState({ fileBARRecon: fileList });
    }

    removeBar = file =>{
        // console.log(file);
        var id = file.uid.toString().split("_");
        mPaidControllers.DELETE_FILE_INVOICE(parseInt(id[0]),"bar",file.name,(r)=>{
            // console.log(r);
        });
        this.setState(state => {
            const index = state.fileBARRecon.indexOf(file);
            const newFileList = state.fileBARRecon.slice();
            newFileList.splice(index, 1);
            return {
                fileBARRecon: newFileList,
            };
        });
    }
    
    uploadBar = async options => {

        const { onSuccess, onError, file, onProgress } = options;
        const formData = new FormData();
        const config = {
          headers: { "content-type": "multipart/form-data" },
          onUploadProgress: event => {
            const percent = Math.floor((event.loaded / event.total) * 100);
            this.setState({UploadInvProgress:percent})
            if (percent === 100) {
              setTimeout(() => {
                this.setState({UploadInvProgress:0});
              }, 1000);
            }
            onProgress({ percent: (event.loaded / event.total) * 100 });
          }
        };
        formData.append("id", this.state.InvSelected);
        formData.append("periode", this.state.PeriodeInvoice);
        formData.append("ad_code", this.state.AdCode);
        formData.append("ad_name", this.state.AdName);
        formData.append("bar_recon", file);
        reqwest({
            url: mHelper.URL_API() + "paid-invoice/upload_bar_recon",
            method: 'post',
            headers: {
                "Authorization": "Bearer " + isLogin.token
            },
            processData: false,
            data: formData,
            success: (r) => {
                onSuccess("Ok");
                this.setState({fileBARRecon:r.data});
                if(r.success === false){
                    Modal.info({
                        title: 'Error',
                        content: (
                          <div>
                            <p>{r.message}</p>
                          </div>
                        ),
                        onOk() {},
                    });
                }
            },
            error: (err) => {
                onError({ err });
                // callback({success:false, data:[], message : "add paid invoice  error"});
            },
        });
    }

    //UPLOAD SUMMARY
    handleUploadSummaryChange = info => {
        let fileList = [...info.fileList];
        this.setState({ fileSummary: fileList });
    }

    removeSummary = file =>{
        // console.log(file);
        mPaidControllers.DELETE_FILE_INVOICE(parseInt(file.uid),"summary",file.name,(r)=>{
            // console.log(r);
        });
        this.setState(state => {
            const index = state.fileSummary.indexOf(file);
            const newFileList = state.fileSummary.slice();
            newFileList.splice(index, 1);
            return {
                fileSummary: newFileList,
            };
        });
    }

    uploadSummary = async options => {
        const { onSuccess, onError, file, onProgress } = options;
        const formData = new FormData();
        const config = {
          headers: { "content-type": "multipart/form-data" },
          onUploadProgress: event => {
            const percent = Math.floor((event.loaded / event.total) * 100);
            this.setState({UploadInvProgress:percent})
            if (percent === 100) {
              setTimeout(() => {
                this.setState({UploadInvProgress:0});
              }, 1000);
            }
            onProgress({ percent: (event.loaded / event.total) * 100 });
          }
        };
        formData.append("id", this.state.InvSelected);
        formData.append("periode", this.state.PeriodeInvoice);
        formData.append("ad_code", this.state.AdCode);
        formData.append("ad_name", this.state.AdName);
        formData.append("doc_summary", file);
        reqwest({
            url: mHelper.URL_API() + "paid-invoice/upload_summary",
            method: 'post',
            headers: {
                "Authorization": "Bearer " + isLogin.token
            },
            processData: false,
            data: formData,
            success: (r) => {
                onSuccess("Ok");
                this.setState({fileSummary:[r.data]});
            },
            error: (err) => {
                onError({ err });
            },
        });
    }


    drawerMessageOnClose = () => {
        this.setState({drawerMessage:false});
    }

    drawerMessageOnOpen = () => {
        this.setState({drawerMessage:true});
    }

    // propsUploadInvoice = {
    //     name: 'doc_invoice',
    //     action: mHelper.URL_API()+"paid-invoice/upload_invoice",
    //     headers: {
    //         "Authorization" : "Bearer "+isLogin.token,
    //     },
    //     onChange: this.handleUploadChange,
    //     file:{ response: '{"status": "success"}' },
    //     multiple: false,
    //     listType:'pdf',
    //     accept:".pdf",
    //     onSuccess : (response, file) => {
    //         console.log(file);
    //         // file.status = 'done'
    //         // console.log(file);
    //         // this.setState({ fileList : [] });
    //         // this.onReloadTable();
    //     },
    //     // showUploadList:true
    // }


    columns = [
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            render: text => {
                return(
                    <div>
                        <Tooltip placement="bottom" title={"Edit Invoice Upload"}>
                            <Button className="btn-tools btn-info" size="small" icon={<EditOutlined /> } onClick={(e)=> {this.handelUpdateInvoice(text)}} ></Button>
                        </Tooltip>
                        <Tooltip placement="bottom" title={"Delete Invoice Upload"}>
                            <Button type="danger" className="btn-tools" size="small" icon={<DeleteOutlined /> } onClick={(e)=> {this.handleDeleteInvoice(text)}}></Button>
                        </Tooltip>
                    </div>
                )
            }
        },
        {
            title: 'Periode',
            dataIndex: 'periode_trx',
            key: 'periode_trx',
            render: text => <span>{text}</span>,
        },
        {
          title: 'Kode AD',
          dataIndex: 'ad_code',
          key: 'ad_code',
          render: text => <span>{text}</span>,
        },
        {
          title: 'Nama AD',
          dataIndex: 'ad_name',
          key: 'ad_name',
        },
        {
          title: 'Nomor Invoice',
          dataIndex: 'inv_number',
          key: 'inv_number',
        },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
        },
        
        {
            title: 'Invoice Qty',
            dataIndex: 'inv_qty',
            key: 'inv_qty',
        },
        {
            title: 'Price',
            dataIndex: 'price',
            key: 'price',
        },
        {
            title: 'PPH Amount',
            dataIndex: 'pph_amount',
            key: 'pph_amount',
        },
        {
            title: 'Total Amount',
            dataIndex: 'total_amount',
            key: 'total_amount',
        },
        {
            title: 'Remarks',
            dataIndex: 'remarks',
            key: 'remarks',
        },
        {
            title: 'File',
            dataIndex: 'file',
            key: 'file',
            render: text => {
                const menu = (
                    <Menu onClick={(e)=>this.handleOpenFile(e,text.info)}>
                        {
                            Object.keys(text.info).map(label =>(
                                <Menu.Item key={label}>
                                    <span>{text.info[label].title}</span>
                                </Menu.Item>
                            )
                        )}
                    </Menu>
                );
                return(
                    <Dropdown overlay={menu} trigger={['click']}>
                       <Button className="primaryButton" size="small" >Open <DownOutlined /></Button> 
                    </Dropdown>
                )
            }
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
        },
        {
            title: 'Note',
            dataIndex: 'note',
            key: 'note',
            render: text => {
                if(text.hold_state == 1 && text.note_state === 1){
                    return(
                        <Tooltip placement="top" title={text.desc}>
                            <Button  className="btn-tools btn-error" size="small" style={{backgroundColor:"#FF0000",color:"#FFFFFF"}}><WarningOutlined /></Button>
                        </Tooltip>
                    )
                }else{
                    if(text.hold_state == 0){
                        return(
                            <Tooltip placement="top" title="Tolong kirimkan file hardcopy nya ya, jika sudah abaikan informasi ini !">
                                <Button  className="btn-tools btn-warning" size="small" ><WarningOutlined /></Button>
                            </Tooltip>
                        )
                    }else{
                        return("-");
                    }
                }
            }
        }
    ];

    render(){
        const { uploading, fileInvoice,fileFakturPajak,fileBARRecon , fileSummary} = this.state;
        // const fileInvoiceProps = {
        //     name: 'doc_invoice',
        //     action: mHelper.URL_API()+"paid-invoice/upload_invoice",
        //     headers: {
        //         "Authorization" : "Bearer "+isLogin.token,
        //     },
        //     multiple: false,
        //     listType:'pdf',
        //     accept:".pdf",
        //     onRemove: file => {
        //         this.setState(state => {
        //         const index = state.fileInvoice.indexOf(file);
        //             const newFileList = state.fileInvoice.slice();
        //             newFileList.splice(index, 1);
        //             return {
        //                 fileInvoice: newFileList,
        //             };
        //         });
        //     },
        //     // beforeUpload: file => {
        //     //     this.setState(state => ({
        //     //         fileInvoice: [...state.fileInvoice, file],
        //     //     }));
        //     //     return false;
        //     // },
        //     fileInvoice,
        // };
        // const fileFakturPajakProps = {
        //     onRemove: file => {
        //       this.setState(state => {
        //         const index = state.fileFakturPajak.indexOf(file);
        //         const newFileList = state.fileFakturPajak.slice();
        //         newFileList.splice(index, 1);
        //         return {
        //             fileFakturPajak: newFileList,
        //         };
        //       });
        //     },
        //     beforeUpload: file => {
        //       this.setState(state => ({
        //         fileFakturPajak: [...state.fileFakturPajak, file],
        //       }));
        //       return false;
        //     },
        //     fileFakturPajak,
        // };

        const fileBARReconProps = {
            onRemove: file => {
              this.setState(state => {
                const index = state.fileBARRecon.indexOf(file);
                const newFileList = state.fileBARRecon.slice();
                newFileList.splice(index, 1);
                return {
                    fileBARRecon: newFileList,
                };
              });
            },
            beforeUpload: file => {
              this.setState(state => ({
                fileBARRecon: [...state.fileBARRecon, file],
              }));
              return false;
            },
            fileBARRecon,
        };

        return (
            <div >
                <Breadcrumb>
                    <Breadcrumb.Item>
                    <div className="TitlePage">
                        <WalletOutlined className="icon" /><DoubleRightOutlined className="iconArrow" /> <h3>Upload Invoice</h3>
                    </div>
                    </Breadcrumb.Item>
                </Breadcrumb>
                <Row>
                    <HeaderTitle onChangeDate={this.onChangeDate} onProcess={this.onProcess} momen={moment(this.state.Periode, 'YYYY-MM')}/>
                    <Col sm={12}  lg={12}>
                        <Card bordered={false} className="box">
                            <Row>
                                <Col sm={12}  lg={12} style={{marginBottom:20}}>
                                    <Button className="primaryButton" icon={<CloudUploadOutlined />}  onClick={this.onUploadInvoice}>
                                        Upload Invoice
                                    </Button>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm={12}  lg={12}>
                                    <Spin spinning={this.state.loadingUploadInvoice} >
                                        <Table columns={this.columns} dataSource={this.state.TableUploadInvoice} />
                                    </Spin>
                                </Col>
                            </Row>
                            <Card style={{boxShadow: '#E3EAFF 1px 1px 3px 1px'}}>
                                <Row>
                                    <Col sm={2}  lg={2}>Draft</Col><Col sm={10}  lg={10}>: Hanya Dealer yang melihat data ini. </Col>
                                    <Col sm={2}  lg={2}>Waiting Validate...</Col><Col sm={10}  lg={10}>: Menunggu data divalidasi oleh link aja.</Col>
                                    <Col sm={2}  lg={2}>Waiting Approval...</Col><Col sm={10}  lg={10}>: Data sudah divalidasi, tinggal menunggu approval.</Col>
                                    <Col sm={2}  lg={2}>Waiting Payment...</Col><Col sm={10}  lg={10}>: Data sudah di approve tinggal menunggu dibayar.</Col>
                                    <Col sm={2}  lg={2}>Review AP</Col><Col sm={10}  lg={10}>: Data sudah di approve, tinggal nunggu review AP selesai.</Col>
                                    <Col sm={2}  lg={2}>Finish</Col><Col sm={10}  lg={10}>: Data transaksi sudah selesai.</Col>
                                    <Col sm={2}  lg={2}>Reject</Col><Col sm={10}  lg={10}>: Data transaksi ditolak.</Col>
                                </Row>
                            </Card>
                        </Card>
                    </Col>
                </Row>
                <Modal
                    width="900px"
                    title="Form Upload Invoice"
                    visible={this.state.modalFormUploadInvoice}
                    footer={null}
                    onCancel={this.onCancelFormUploadInvoice}>
                    <Spin spinning={this.state.loadingUploadInvoice} >
                        <Form {...layout}   ref={formUploadInvoice}  name="configForm" onFinish={this.onFinishFormUploadInvoice}>
                            <Row>
                                <Col sm={6}  lg={6}>
                                  
                                    <Form.Item name="periode" 
                                        rules={[
                                            {
                                            required: true, message: 'Please input Kode Transaksi  !',
                                            },
                                        ]}
                                        label="Periode">
                                        {/* <DatePicker  picker="month"  readOnly />   */}
                                        <Input placeholder=""  readOnly={true}  />
                                    </Form.Item>

                                    <Form.Item name="ad_code" 
                                        rules={[
                                            {
                                            required: true, message: 'Please input Kode AD  !',
                                            },
                                        ]}
                                        label="Kode AD">
                                        <Input placeholder=""   readOnly/>
                                    </Form.Item>
                                    <Form.Item name="ad_name" 
                                        rules={[
                                            {
                                            required: true, message: 'Please input Nama AD  !',
                                            },
                                        ]}
                                        label="Nama AD">
                                        <Input placeholder=""  readOnly />
                                    </Form.Item>
                                    <Form.Item name="bar_attachment" 
                                        label="* Doc BAR Rekon">
                                        <Upload 
                                         onRemove={this.removeBar}
                                         customRequest={this.uploadBar}
                                         fileList={this.state.fileBARRecon}
                                         // defaultFileList={this.state.fileInvoice}
                                         onChange={this.handleUploadBarChange} >
                                            <Button icon={<UploadOutlined />}>Select File BAR Recon</Button>
                                        </Upload>
                                    </Form.Item>
                                    <Form.Item name="summary_attachment" 
                                        
                                        label="* Doc Summary">
                                        <Upload 
                                         onRemove={this.removeSummary}
                                         customRequest={this.uploadSummary}
                                         fileList={this.state.fileSummary}
                                         // defaultFileList={this.state.fileInvoice}
                                         onChange={this.handleUploadSummaryChange}>
                                            <Button icon={<UploadOutlined />}>Select File Summary</Button>
                                        </Upload>
                                    </Form.Item>
                                </Col>
                                <Col sm={6}  lg={6}>
                                    <Form.Item name="inv_date" 
                                        rules={[
                                            {
                                            required: true, message: 'Please input Invoice Date  !',
                                            },
                                        ]}
                                        label="Invoice Date">
                                        {/* <DatePicker  picker="month"  readOnly />   */}
                                        <DatePicker onChange={this.onChangeDateInv} format={"YYYY-MM-DD"} />
                                    </Form.Item>
                                    <Form.Item name="inv_number" 
                                        rules={[
                                            {
                                            required: true, message: 'Please input Nomor Invoice  !',
                                            },
                                        ]}  
                                        label="Nomor Invoice">
                                        {/* <Select
                                            showSearch
                                            style={{ width: 200 }}
                                            onChange={(e) => {this.onUpdateDataInvoice({"inv_number":e.toString()})}}
                                            placeholder="Select nomor invoice"
                                            filterOption={(input, option) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }>

                                            {this.state.invoiceLookup.map((row) => (
                                            <Select.Option value={row.value}>{row.label}</Select.Option>
                                            ))}
                                        </Select> */}
                                         <Input placeholder="" onChange={(e) => {this.onUpdateDataInvoice({"inv_number":e.target.value})}}  />
                                    </Form.Item>
                                    <Form.Item name="inv_attachment" 
                                       
                                        label="* Doc Invoice">
                                        <Upload  
                                        onRemove={this.removeInvoice}
                                        customRequest={this.uploadInvoice}
                                        fileList={this.state.fileInvoice}
                                        // defaultFileList={this.state.fileInvoice}
                                        onChange={this.handleUploadInvoiceChange}>
                                            <Button icon={<UploadOutlined />}>Select File Invoice</Button>
                                        </Upload>
                                        {this.state.UploadInvProgress > 0 ? <Progress percent={this.state.UploadInvProgress} /> : null}
                                    </Form.Item>
                                    <Form.Item name="fp_number" 
                                        rules={[
                                            {
                                            required: true, message: 'Please input Nomor Faktur Pajak  !',
                                            },
                                        ]}
                                        label="Nomor Faktur Pajak">
                                        {/* <Select
                                            showSearch
                                            style={{ width: 200 }}
                                            placeholder="Select nomor faktur pajak"
                                            onChange={(e) => {this.onUpdateDataInvoice({"fp_number":e.toString()})}}
                                            filterOption={(input, option) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }>

                                            {this.state.fakturPajakLookup.map((row) => (
                                            <Select.Option value={row.value}>{row.label}</Select.Option>
                                            ))}
                                        </Select> */}
                                        <Input placeholder="" onChange={(e) => {this.onUpdateDataInvoice({"fp_number":e.target.value})}}  />
                                    </Form.Item>
                                    <Form.Item name="fp_attachment" 
                                        
                                        label="* Doc Faktur Pajak">
                                        <Upload 
                                         onRemove={this.removeFp}
                                         customRequest={this.uploadFp}
                                         fileList={this.state.fileFakturPajak}
                                         // defaultFileList={this.state.fileInvoice}
                                         onChange={this.handleUploadFpChange}>
                                            <Button icon={<UploadOutlined />}>Select File Faktur Pajak</Button>
                                        </Upload>
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Divider orientation="left">INFORMASI PENDUKUNG</Divider>
                            <Row>
                                <Col sm={12}  lg={12} >
                                    <Form.Item name="description"  {...layoutPendukung}
                                        rules={[
                                            {
                                            required: true, message: 'Please input Description  !',
                                            },
                                        ]}
                                        label="Description">
                                        <Input placeholder=""   onChange={(e) => {this.onUpdateDataInvoice({"description":e.target.value})}} />
                                    </Form.Item>
                                    <Form.Item name="qty_trx"  {...layoutPendukung}
                                        rules={[
                                            {
                                            required: true, message: 'Please Invoice Qty !',
                                            },
                                        ]}
                                        label="Invoice Qty">

                                        <InputNumber min={1}  defaultValue={this.state.data_price.qty_trx} onChange={this.onChangeQtyInvoice}   readOnly={true}/>
                                    </Form.Item>
                                    <Form.Item name="price" {...layoutPendukung}
                                        rules={[
                                            {
                                            required: true, message: 'Please input Invoice Price  !',
                                            },
                                        ]}
                                        label="Price">
                                            
                                        <InputNumber style={{width:"400px"}} 
                                            defaultValue={this.state.data_price.price}
                                            min={0} 
                                            formatter={value => `RP ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')} 
                                            parser={value => value.replace(/\RP\s?|(,*)/g, '')}   
                                            readOnly={true}
                                        />
                                    </Form.Item>
                                    <Form.Item name="pph_amount" {...layoutPendukung}
                                        rules={[
                                            {
                                            required: true, message: 'Please input vat amount  !',
                                            },
                                        ]}
                                        label="PPN Amount">
                                            
                                        <InputNumber style={{width:"400px"}} 
                                            defaultValue={this.state.data_price.pph_amount}
                                            min={0} 
                                            formatter={value => `RP ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')} 
                                            parser={value => value.replace(/\RP\s?|(,*)/g, '')}   
                                            readOnly
                                        />
                                    </Form.Item>
                                    <Form.Item name="total_amount" {...layoutPendukung}
                                        rules={[
                                            {
                                            required: true, message: 'Please input total amount !',
                                            },
                                        ]}
                                        label="Total Amount">

                                        <InputNumber style={{width:"400px"}} 
                                            min={0} 
                                            defaultValue={this.state.data_price.total_amount}
                                            formatter={value => `RP ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')} 
                                            parser={value => value.replace(/\RP\s?|(,*)/g, '')}  readOnly
                                        />
                                    </Form.Item>
                                    <Form.Item name="remarks" {...layoutPendukung}
                                        rules={[
                                            {
                                            required: true, message: 'Please input Remarks  !',
                                            },
                                        ]}
                                        label="Remarks">
                                            <TextArea placeholder="" allowClear  onChange={(e) => {this.onUpdateDataInvoice({"remarks":e.target.value})}}/>
                                    </Form.Item>
                                    
                                </Col>
                            </Row>
                            <Divider />
                            <div style={{textAlign: 'right'}}>
                                <Button className="primaryButton" htmlType="submit" >
                                    Submit Invoice
                                </Button>
                            </div>
                        </Form>
                    </Spin>
                </Modal>
                <Drawer
                    title="INVOICE FPJP MESSAGE"
                    placement="right"
                    closable={false}
                    onClose={this.drawerMessageOnClose}
                    visible={this.state.drawerMessage}>

                    <p>Some contents...</p>
                    <p>Some contents...</p>
                    <p>Some contents...</p>

                </Drawer>                        
            </div>
        )
    }
}


export default UploadInvoice;
